import React, { Component } from 'react';
import ShopCard from './ShopCard/ShopCard';
import { ShopItem } from './ShopItem.interface';
import { environments } from 'environments/environments';

class ShopSection extends Component {
  state = {
    shopItems: [] as ShopItem[],
    displayedItems: 0
  }
  lastDisplayed = 0;
  displayTimeout: NodeJS.Timeout | undefined;

  componentDidMount() {
    this.getShopItems();
    document.title = environments.pageTitle +  ' - Suvenýry';
  }

  componentWillUnmount() {
    if (this.displayTimeout) {
      clearTimeout(this.displayTimeout);
    }
  }

  getShopItems() {
    fetch(environments.serverURL + '/data/shop_items.json?anticache=' + Date.now())
      .then(async res => {
        const shopItems: ShopItem[] = await res.json();
        if (shopItems.length) {
          this.setState({ shopItems });
          this.appearShopItem();
        }
      })
      .catch(e => console.error('Seznam suvenýrů nebyl úspěšně načten.\n', e));
  }

  appearShopItem() {
    const newsDisplayedItems = this.state.displayedItems + 1;
    if (this.lastDisplayed === newsDisplayedItems) {
      return;
    }
    this.lastDisplayed = newsDisplayedItems;
    this.setState({ displayedItems: newsDisplayedItems });
    this.displayTimeout = setTimeout(() => {
      if (newsDisplayedItems < this.state.shopItems.length) {
        this.appearShopItem();
      }
    }, 175);
  }

  render() {
    const renderCards = this.state.shopItems.map((item, index) => {
      const isHidden = this.state.displayedItems <= index;
      return isHidden ? null : <ShopCard key={index} item={item} />;
    });
    const orderStyle = {
      textAlign: 'center' as any,
      marginBottom: '36px'
    }

    return (
      <div>
        <p style={orderStyle}>
          Uvedené zboží lze objednat na dobírku na adrese <b><a href="mailto:randy@volny.cz">randy@volny.cz</a></b>.<br />
          Do e-mailu uveďte celou poštovní adresu a počet kusů.
        </p>
        {renderCards}
      </div>
    );
  }
}

export default ShopSection;